<h2 mat-dialog-title>
  <i class="fa fa-circle-info" aria-hidden="true"></i>&nbsp; Shared group can't be edited
</h2>
<form [formGroup]="formGroup" (submit)="create()">
  <mat-dialog-content>
    <p class="prompt-message">
      You can't edit a shared group. To keep your changes, create a new independent group based on this one.
    </p>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Enter new group name</mat-label>
      <input matInput formControlName="name" autocomplete="off">
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()" [disabled]="saving">Cancel</button>
    <button mat-raised-button type="submit" color="primary" [disabled]="saving || formGroup.invalid">
      @if (saving) {
        <mat-progress-spinner mode="indeterminate" diameter="16"></mat-progress-spinner>
      } @else {
        <i class="fa fa-fw fa-plus" aria-hidden="true"></i>
      }
      Create Group
    </button>
  </mat-dialog-actions>
</form>